export enum UpgradeIneligibleErrorType {
  UPGRADE_ORDER_PLACED = 'UPGRADE_ORDER_PLACED',
  MAVERICK = 'MAVERICK',
  ELITE = 'ELITE',
  NON_ADMIN_FAMILY_MEMBER = 'NON_ADMIN_FAMILY_MEMBER',
  PAUSED = 'PAUSED',
  PENDING = 'PENDING',
  PAYMENT_FAILURE = 'PAYMENT_FAILURE',
  COUNTRY_INELIGIBLE_FOR_LIFE_MAVERICK_UPGRADE = 'COUNTRY_INELIGIBLE_FOR_LIFE_MAVERICK_UPGRADE',
  BRAZIL = 'BRAZIL',
  ISRAEL = 'ISRAEL',
}
